import * as React from 'react';
import Profil from '../dashboard/Profil';
import ToolBox from '../dashboard/ToolBox';
import '../dashboard/dashboard.css';
import {
  Avatar,
  Box,
  Button,
  CssBaseline,
  Divider,
  Drawer,
  Stack,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import {useUserInfo} from '../userInfo/hooks/useUserInfo';
import {Footer} from '../../components';
import {Header} from '../../components';
import axios from '../../axios';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import Dialog from '@mui/material/Dialog';
import SendIcon from '@mui/icons-material/Send';
import FAQBox from "../faq/FAQBox";

export const withNavigation = Component => {
  return props => {
    const [open, setOpen] = React.useState(true);
    const {switchMode} = useUserInfo();
    const {profil, revertAccount} = useUserInfo();
    const [showModalMenu, setShowModalMenu] = React.useState(false);

    const handleDrawerOpen = () => {
      setOpen(true);
    };

    const handleDrawerClose = () => {
      setOpen(false);
    };
    const {mode} = useDarkMode();

    return (
      <Stack direction={'column'}>
        <Stack direction={'row'}>
          {open && (
            <Stack
              className={'side_menu_container'}
              spacing={3}
              sx={{
                backgroundColor: `${mode.settings.cardBackgroundColor} !important`,
                display: {xs: 'none', md: 'none', lg: 'block'},
              }}>
              <Stack direction={'row'} alignItems={'center'}>
                <IconButton
                  color="black"
                  aria-label="Fermer le menu à droite"
                  onClick={handleDrawerClose}
                  edge="start"
                  sx={{mr: 2, width: 50}}>
                  <CloseIcon style={{color: mode.settings.textColor3}} />
                </IconButton>
                <Typography
                  color={mode.settings.textColor3}
                  variant={'subtitle8'}>
                  Fermer le menu
                </Typography>
              </Stack>
              <Profil />
              <ToolBox />
              <FAQBox />
            </Stack>
          )}
          {!open && (
            <Stack
              className={'side_menu_container'}
              spacing={3}
              alignItems={'center'}
              sx={{
                backgroundColor: mode.settings.cardBackgroundColor,
                display: {xs: 'none', md: 'none', lg: 'block'},
              }}>
              <Stack direction={'row'} alignItems={'center'}>
                <IconButton
                  color="black"
                  aria-label="Ouvrir le menu à droite"
                  onClick={handleDrawerOpen}
                  edge="start"
                  sx={{mr: 2}}>
                  <MenuIcon style={{color: mode.settings.textColor3}} />
                </IconButton>
                <Typography
                  color={mode.settings.textColor3}
                  variant={'subtitle16'}>
                  Ouvrir le menu
                </Typography>
              </Stack>
              {profil && (
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  id={'profilAvatar'}>
                  <Avatar
                    sx={{width: 69, height: 69}}
                    src={`${axios.defaults.apiBaseURL}/${profil.image}`}
                    aria-label={'Photo de profil'}
                  />
                  <Typography
                    variant={'subtitle1'}
                    color={mode.settings.textColor3} sx={{textAlign : 'center'}}>
                    {profil.first_name} {profil.last_name}
                  </Typography>
                </Stack>
              )}
            </Stack>
          )}
          <Stack
            direction={'column'}
            alignItems={'center'}
            sx={{
              width: '100%',
              marginTop: '7px',
              px: 2,
              backgroundColor: mode.settings.backgroundColor,
            }}>
            {switchMode ? (
              <Stack
                direction={'column'}
                sx={{
                  background: '#FFEAF0',
                  height: '65px',
                  borderRadius: '5px',
                  padding: '20px',
                  width: {xs: '90%', md: '80%', lg: '69%'},
                  marginBottom: '15px',
                }}
                alignItems={'center'}>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flexWrap={'wrap'}
                  justifyContent={'center'}>
                  <img
                    style={{marginRight: 10}}
                    src="assets/icon/info.png"
                    alt="Information profile"
                  />
                  <Typography
                    style={{marginRight: 10}}
                    variant={'subtitle3'}
                    color={'#263238'}>
                    Vous êtes connecté en tant que{' '}
                  </Typography>
                  {profil && (
                    <Typography variant={'subtitle1'} color={'#263238'}>
                      {profil.email}.
                    </Typography>
                  )}
                </Stack>
                <Button className="btn" onClick={() => revertAccount()}>
                  <Typography variant={'subtitle3'} component="span">
                    Retourner à mon compte
                  </Typography>
                </Button>
              </Stack>
            ) : (
              <></>
            )}
            <Button
              className="buttonOhs"
              startIcon={
                <SendIcon role="img" aria-label={'Publier le commentaire'} />
              }
              sx={{
                paddingLeft: 15,
                textAlign: 'left',
                marginBottom: 5,
                display: {xs: 'flex', md: 'flex', lg: 'none'},
              }}
              onClick={() => setShowModalMenu(true)}>
              <Typography variant={'subtitle1'}>
                Ouvrir la navigation
              </Typography>
            </Button>
            <Dialog
              open={showModalMenu}
              onClose={() => setShowModalMenu(false)}>
              <Stack
                sx={{backgroundColor: 'lightgray', padding: '20px'}}
                spacing={2}>
                <Profil />
                <ToolBox />
                <FAQBox />
              </Stack>
            </Dialog>
            <Component {...props} />
          </Stack>
        </Stack>
        <Footer />
      </Stack>
    );
  };
};
